import Tabs from "@/components/Tabs";
import AppLayout from "@/layouts/AppLayout";
import Breadcrumb from "@/components/Breadcrumb";
import PageHeading from "@/components/PageHeading";
import { useNavigate } from "@/router";
import { useLocation } from "react-router-dom";
import { getDuesManagementNavLinks } from "../_utils";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const navLinks = getDuesManagementNavLinks();

  return (
    <AppLayout interior bottomBar navLinks={navLinks}>
      <Breadcrumb title="Dues Management" backLink={{ to: "/billing/dues-management" }} />
      <PageHeading title="Reporting" compact />
      <Tabs
        tabItems={[
          {
            label: "Unpaid Dues",
            to: "/billing/dues-management/reporting/unpaid-dues" as const
          },
          {
            label: "Suspensions",
            to: "/billing/dues-management/reporting/suspensions" as const
          },
          {
            label: "Terminations",
            to: "/billing/dues-management/reporting/terminations" as const
          }
        ].map(({ label, to }) => ({
          label,
          onClick: () => navigate(to),
          active: (pathname.endsWith("/") ? pathname.slice(0, -1) : pathname) === to
        }))}
      />
      <div className="flex flex-col">{children}</div>
    </AppLayout>
  );
}
